import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=05845190&scoped=true&"
import script from "./FormBuilder.vue?vue&type=script&lang=js&"
export * from "./FormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilder.vue?vue&type=style&index=0&id=05845190&lang=scss&scoped=true&"
import style1 from "./FormBuilder.vue?vue&type=style&index=1&id=05845190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05845190",
  null
  
)

export default component.exports